// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { optimismGoerli as _optimismGoerli } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the optimismGoerli chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 420
 * Chain Name: Optimism Goerli
 * Default Block Explorer: https://goerli-optimism.etherscan.io
 * Default RPC URL: https://goerli.optimism.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { optimismGoerli } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: optimismGoerli,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const optimismGoerli = createCommon({
	..._optimismGoerli,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
